import BrowseSfxPage from '@/components/_pages/BrowseSfxPage';
import { createCollectionGetServerSideProps } from '@/utils/pages/get-collection-server-side-props';

// Collection detail pages are real routes (not a middleware rewrite onto the
// category catch-all) so client-side navigation resolves to a data route and
// the page renders with its props. See get-collection-server-side-props.ts.
export const getServerSideProps = createCollectionGetServerSideProps('sfx');
export default BrowseSfxPage;